import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordInputComponent } from './password-input.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PasswordInputHeaderComponent } from './password-input-header.component';
import { ButtonModule, InputModule } from '@lib/components';
import { GetBasicReservationInformationStoreServiceModule } from '@lib/services/get-basic-reservation-information-store/get-basic-reservation-information-store.module';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [PasswordInputComponent, PasswordInputHeaderComponent],
  providers: [],
  imports: [
    CommonModule,
    TranslateModule,
    StaticMsgModule,
    FormsModule,
    ReactiveFormsModule,
    InputModule,
    ButtonModule,
    GetBasicReservationInformationStoreServiceModule,
  ],
  exports: [PasswordInputComponent, PasswordInputHeaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PasswordInputModule {}
